import React from 'react';
import { type LucideIcon } from 'lucide-react';

interface PageShellProps {
  title: string;
  subtitle?: string;
  icon?: LucideIcon;
  iconColor?: string;
  actions?: React.ReactNode;
  /** Reduce padding for full-canvas pages (ReactFlow, maps) */
  compact?: boolean;
  children: React.ReactNode;
}

export default function PageShell({
  title,
  subtitle,
  icon: Icon,
  iconColor = 'bg-blue-600',
  actions,
  compact = false,
  children,
}: PageShellProps) {
  return (
    <div className={compact ? 'h-full flex flex-col' : 'space-y-6'}>
      {/* Header */}
      <div className={`flex items-start justify-between ${compact ? 'px-6 pt-5 pb-3' : ''}`}>
        <div className="flex items-center gap-3 animate-fade-in">
          {Icon && (
            <div className={`flex-shrink-0 w-10 h-10 rounded-lg ${iconColor} flex items-center justify-center`}>
              <Icon className="w-5 h-5 text-white" />
            </div>
          )}
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
            {subtitle && (
              <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>
            )}
          </div>
        </div>
        {actions && (
          <div className="flex items-center gap-2 animate-fade-in">
            {actions}
          </div>
        )}
      </div>

      {/* Content */}
      {compact ? (
        <div className="flex-1 min-h-0">{children}</div>
      ) : (
        <div className="space-y-6">{children}</div>
      )}
    </div>
  );
}
